<template>
  <MDropdown v-if="!disabled" ref="dropdownMenu">
    <template v-slot:trigger>
      <MButton
        id="action-btn"
        variant="transparent"
        class="text-neutral"
        :shadow="false"
        shape="circle"
      >
        <MIcon name="ellipsis-v" size="2x" />
      </MButton>
    </template>
    <template v-slot:menu>
      <MMenu class="action-menu">
        <MMenuItem
          v-if="
            (movement.statusId === requestedStatusId &&
              movement.approvalStatus === 'not_requested') ||
            movement.statusId === requestedReturnStatusId ||
            ['transfer_approval', 'return_approval'].indexOf(transferStage) >= 0
          "
          id="approve-action-item"
        >
          <ApprovalAction
            :module-name="moduleName"
            :parent-id="movement.id"
            :resource-name="movement.name"
            @trigger="hide"
            @done="$emit('approval-changed')"
          />
        </MMenuItem>
        <MMenuItem
          v-if="
            movement.statusId !== completedStatusId &&
            movement.statusId !== cancelledStatusId
          "
          id="cancel-asset-movement-item"
        >
          <CancelAssetMovement
            :movement="movement"
            :module-name="moduleName"
            :cancelled-status-id="cancelledStatusId"
            :update-api="updateApi"
            @trigger="hide"
          />
        </MMenuItem>
        <MMenuItem
          v-if="
            movement.statusId !== cancelledStatusId &&
            (movement.approvalStatus === 'approved' ||
              movement.approvalStatus === 'pre_approved')
          "
          id="print-btn"
        >
          <Print
            :resource-id="movement.id"
            :resource="movement"
            :module-name="moduleName"
            @trigger="hide"
            @done="hide"
          />
        </MMenuItem>
      </MMenu>
    </template>
  </MDropdown>
</template>

<script>
import ApprovalAction from '@components/approval/approval-action'
import CancelAssetMovement from './action-menu-items/cancel-asset-movement'
import Print from './action-menu-items/print'
export default {
  name: 'ActionMenu',
  components: {
    ApprovalAction,
    CancelAssetMovement,
    Print,
  },
  props: {
    moduleName: { type: String, required: true },
    movement: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
    updateApi: { type: Function, default: undefined },
    requestedStatusId: { type: Number, default: 0 },
    requestedReturnStatusId: { type: Number, default: 0 },
    completedStatusId: { type: Number, default: 0 },
    cancelledStatusId: { type: Number, default: 0 },
    transferStage: { type: String, default: undefined },
  },
  computed: {
    // allowAskForApproval() {
    //   return (
    //     [this.$constants.ASSET_MOVEMENT].indexOf(this.moduleName) >= 0 &&
    //     !this.disabled
    //   )
    // },
  },
  methods: {
    hide() {
      this.$refs.dropdownMenu.hide()
    },
  },
}
</script>
